import { ChangeDetectionStrategy, Component, effect, input, output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ProductType } from '../../common';

type ProductTypeOption<T> = { value: T; label: string };

@Component({
    selector: 'ca-product-filters',
    standalone: false,
    templateUrl: './product-filters.component.html',
    styleUrl: './product-filters.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductFiltersComponent {
    productName = input<string>();
    productType = input<ProductType>();
    productNameControl: FormControl = new FormControl('');
    productTypeControl: FormControl = new FormControl('');

    setProductName = effect(() => {
        this.productNameControl.setValue(this.productName());
    });

    setProductType = effect(() => {
        this.productTypeControl.setValue(this.productType());
    });

    readonly productTypes: ReadonlyArray<ProductTypeOption<ProductType>> = (Object.values(ProductType) as ProductType[]).map(value => ({
        value,
        label: `CA.DEVICE_TYPE.${value}`
    }));

    filter = output<{ productName: string; productType: ProductType }>();

    applyFilters(): void {
        this.filter.emit(this.filterValue);
    }

    private get filterValue(): { productName: string; productType: ProductType } {
        return {
            productName: this.productNameControl.value || '',
            productType: this.productTypeControl.value || ''
        };
    }
}
